/* eslint-disable */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
/**
 * Is node.js current env.
 */
var isNode = typeof global === 'object' && (typeof window === 'undefined' ||
    /* istanbul ignore next */
    global !== window);
/**
 * Global styles shared context property name.
 * @public
 */
export var CSS_GLOBAL_KEY = '$CSS$IN$JS$GLOBALS$';
/**
 * Local styles shared context property name.
 * @public
 */
export var CSS_LOCALS_KEY = '$CSS$IN$JS$LOCALS$';
/**
 * Default options values.
 * @public
 */
export var defaultStylesInjectOptions = {
    useConstructableStylesheet: true,
    useNodeGlobal: true,
    useStyleTag: true,
};
/**
 * Inject stylesheet to global on node or to the document DOM on the browser
 * @public
 * @param stylesheetKey - the unique stylesheet key
 * @param stylesheetBody - the stylesheet body
 * @param options - inject options
 * @param serverSide - force server/client approach
 */
export function injectStyles(stylesheetKey, stylesheetBody, options, serverSide) {
    var _a, _b;
    var _c, _d, _e, _f;
    if (serverSide === void 0) { serverSide = isNode; }
    // prepare options
    var _g = __assign(__assign({}, defaultStylesInjectOptions), options), useNodeGlobal = _g.useNodeGlobal, useConstructableStylesheet = _g.useConstructableStylesheet, useStyleTag = _g.useStyleTag, useNounce = _g.useNounce;
    // if we are on the node.js
    // and node side injection is enabled
    // and style is not already registered globally
    if (serverSide && useNodeGlobal && !((_c = global[CSS_GLOBAL_KEY]) === null || _c === void 0 ? void 0 : _c[stylesheetKey])) {
        if (global[CSS_LOCALS_KEY]) {
            if (!global[CSS_LOCALS_KEY][stylesheetKey]) {
                // if there is a local css registry
                // injecting to locals registry
                global[CSS_LOCALS_KEY][stylesheetKey] = stylesheetBody;
            }
        }
        else {
            // if there is no local css registry and style is not already injected globally
            // injecting to global registry
            global[CSS_GLOBAL_KEY] = __assign(__assign({}, global[CSS_GLOBAL_KEY]), (_a = {}, _a[stylesheetKey] = stylesheetBody, _a));
        }
        return;
    }
    // if we are on the browser side
    // and style is not already registered
    // and client side injection is enabled
    if (!serverSide
        && !((_d = window[CSS_GLOBAL_KEY]) === null || _d === void 0 ? void 0 : _d[stylesheetKey])
        && (useConstructableStylesheet || useStyleTag)) {
        // marking style as injected
        window[CSS_GLOBAL_KEY] = __assign(__assign({}, window[CSS_GLOBAL_KEY]), (_b = {}, _b[stylesheetKey] = true, _b));
        // if constructable stylesheet flag is enabled and available
        if (useConstructableStylesheet && document.adoptedStyleSheets) {
            // we are using constructable stylesheet injection method
            var stylesheet = new CSSStyleSheet();
            stylesheet.replace(stylesheetBody);
            document.adoptedStyleSheets = __spreadArray(__spreadArray([], document.adoptedStyleSheets), [stylesheet]);
            return;
        }
        // if style tag flag is enabled
        if (useStyleTag) {
            // we are injecting stylesheet by styles tag
            var styleElement = document.createElement('style');
            useNounce && styleElement.setAttribute('nounce', useNounce);
            /* istanbul ignore if */
            if (styleElement.styleSheet) {
                styleElement.styleSheet.cssText += stylesheetBody;
            }
            else {
                styleElement.textContent += stylesheetBody;
            }
            (_f = (document.head ||
                (
                /* istanbul ignore next */
                (_e = document.getElementsByTagName('head')) === null || _e === void 0 ? void 0 : _e[0]))) === null || _f === void 0 ? void 0 : _f.appendChild(styleElement);
        }
    }
}
//# sourceMappingURL=inject-styles.js.map